import { render, staticRenderFns } from "./CloHeading.vue?vue&type=template&id=4d9911e1&"
import script from "./CloHeading.vue?vue&type=script&lang=js&"
export * from "./CloHeading.vue?vue&type=script&lang=js&"
import style0 from "./CloHeading.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports